import { createRouter, createWebHistory } from "vue-router"
import { session, fetchContext } from "@/data/session"

const ADMIN_ROLES = ["System Manager", "Administrator"]

const routes = [
	{ path: "/login", name: "Login", component: () => import("@/pages/Login.vue"), meta: { public: true } },

	{
		path: "/",
		component: () => import("@/components/AppShell.vue"),
		children: [
			{ path: "", redirect: () => session.home },

			{ path: "director", name: "Director", component: () => import("@/pages/DirectorHome.vue"),
				meta: { title: "Executive Overview", roles: ["Project Director"] } },
			{ path: "pm", name: "PM", component: () => import("@/pages/PMHome.vue"),
				meta: { title: "Project Manager", roles: ["Construction Project Manager"] } },
			{ path: "planning", name: "Planning", component: () => import("@/pages/PlanningHome.vue"),
				meta: { title: "Planning", roles: ["Planning Engineer"] } },
			{ path: "qs", name: "QS", component: () => import("@/pages/QSHome.vue"),
				meta: { title: "Quantity Surveying", roles: ["Quantity Surveyor"] } },
			{ path: "site", name: "SiteEngineer", component: () => import("@/pages/SiteEngineerHome.vue"),
				meta: { title: "Site Engineering", roles: ["Site Engineer"] } },
			{ path: "procurement", name: "Procurement", component: () => import("@/pages/ProcurementHome.vue"),
				meta: { title: "Procurement", roles: ["Procurement Officer"] } },
			{ path: "store", name: "Store", component: () => import("@/pages/StoreHome.vue"),
				meta: { title: "Stores", roles: ["Store Keeper"] } },
			{ path: "equipment", name: "Equipment", component: () => import("@/pages/EquipmentHome.vue"),
				meta: { title: "Equipment", roles: ["Equipment Manager"] } },
			{ path: "assets", name: "AssetMovement", component: () => import("@/pages/AssetMovementHome.vue"),
				meta: { title: "Asset Movement" } },
			{ path: "qaqc", name: "QAQC", component: () => import("@/pages/QAQCHome.vue"),
				meta: { title: "QA / QC", roles: ["QA/QC Engineer"] } },
			{ path: "hse", name: "HSE", component: () => import("@/pages/HSEHome.vue"),
				meta: { title: "HSE", roles: ["HSE Officer"] } },
			{ path: "admin", name: "Admin", component: () => import("@/pages/AdminHome.vue"),
				meta: { title: "Administration", roles: ADMIN_ROLES } },

			// Generic config-driven module pages — see data/deskModules.js
			{ path: "d/:module", name: "DeskListPage", component: () => import("@/pages/DeskListPage.vue") },
			{ path: "d/:module/:name", name: "DeskFormPage", component: () => import("@/pages/DeskFormPage.vue") },
		],
	},

	{ path: "/:pathMatch(.*)*", name: "NotFound", component: () => import("@/pages/NotFound.vue"), meta: { public: true } },
]

const router = createRouter({
	history: createWebHistory("/constructionos"),
	routes,
})

router.beforeEach(async (to) => {
	if (to.meta.public) return true

	if (!session.isLoggedIn) {
		await fetchContext()
	}
	if (!session.isLoggedIn) {
		return { name: "Login", query: { redirect: to.fullPath } }
	}

	const isAdmin = session.roles.some((r) => ADMIN_ROLES.includes(r))
	if (to.meta.roles && !isAdmin && !to.meta.roles.some((r) => session.roles.includes(r))) {
		return { path: session.home, replace: true }
	}

	return true
})

export default router
